import { render, staticRenderFns } from "./cadastro_novo_paciente.vue?vue&type=template&id=206deadc&scoped=true&"
import script from "./cadastro_novo_paciente.vue?vue&type=script&lang=js&"
export * from "./cadastro_novo_paciente.vue?vue&type=script&lang=js&"
import style0 from "./cadastro_novo_paciente.vue?vue&type=style&index=0&id=206deadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206deadc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VProgressCircular,VRadio,VRadioGroup,VTextField})
